import { byId } from './domUtils';
import type { Root } from './prototypeTypes';

const hydrationGenerations = new WeakMap<Root, number>();

export function resetTopicInformationBand(root: Root): number {
	const generation = (hydrationGenerations.get(root) ?? 0) + 1;
	hydrationGenerations.set(root, generation);
	const band = byId(root, 'topic-info-band');
	if (band) {
		band.hidden = true;
		band.classList.remove('topic-info-band--single');
	}
	const summaryBlock = byId(root, 'topic-summary-block');
	if (summaryBlock) {
		summaryBlock.hidden = true;
		(summaryBlock as HTMLDetailsElement).open = true;
	}
	const summary = byId(root, 'topic-summary');
	if (summary) summary.textContent = '';
	const takeaways = byId(root, 'topic-takeaways-block');
	if (takeaways) {
		(takeaways as HTMLDetailsElement).open = false;
		takeaways.replaceChildren();
		takeaways.hidden = true;
	}
	return generation;
}

export function isCurrentTopicHydration(root: Root, generation: number): boolean {
	return hydrationGenerations.get(root) === generation;
}
